import apiClient from './index';
import {
  NotificationScheduleCreate,
  NotificationScheduleRead,
  NotificationScheduleUpdate,
} from './types';

export const notificationSchedulesApi = {
  async list(buildingId: string): Promise<NotificationScheduleRead[]> {
    const res = await apiClient.get<NotificationScheduleRead[]>('/notification-schedules/', {
      params: { building_id: buildingId },
    });
    return res.data;
  },
  async create(payload: NotificationScheduleCreate): Promise<NotificationScheduleRead> {
    const res = await apiClient.post<NotificationScheduleRead>('/notification-schedules/', payload);
    return res.data;
  },
  async update(id: string, payload: NotificationScheduleUpdate): Promise<NotificationScheduleRead> {
    const res = await apiClient.put<NotificationScheduleRead>(`/notification-schedules/${id}`, payload);
    return res.data;
  },
  async remove(id: string): Promise<void> {
    await apiClient.delete(`/notification-schedules/${id}`);
  },
};
